/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Psod_TitleInputs */

const fr_psod_title = /** @type {(inputs: Psod_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue`)
};

const en_psod_title = /** @type {(inputs: Psod_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred`)
};

/**
* | output |
* | --- |
* | "An error occurred" |
*
* @param {Psod_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const psod_title = /** @type {((inputs?: Psod_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Psod_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_psod_title(inputs)
	return en_psod_title(inputs)
});